import { Injectable, inject } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { tap } from 'rxjs';
import { ConfigConstants } from '../../constants/config.constants';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationFeatureService {
  private msalGuardConfig = inject<MsalGuardConfiguration>(MSAL_GUARD_CONFIG);
  private authService = inject(MsalService);

  getInstance() {
    return this.authService.instance;
  }

  handleRedirectObservable() {
    return this.authService.handleRedirectObservable().pipe(
      tap((result) => {
        if (result?.account) {
          this.authService.instance.setActiveAccount(result.account);
        }
      }),
    );
  }

  isAuthenticated(): boolean {
    if (this.authService.instance.getActiveAccount()) return true;

    const accounts = this.authService.instance.getAllAccounts();
    if (accounts.length > 0) {
      this.authService.instance.setActiveAccount(accounts[0]);
      return true;
    }

    return false;
  }

  checkAndSetActiveAccount(): void {
    if (!this.authService.instance.getActiveAccount()) {
      const accounts = this.authService.instance.getAllAccounts();
      if (accounts.length > 0) {
        this.authService.instance.setActiveAccount(accounts[0]);
      }
    }
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  logout(): void {
    this.authService.logoutRedirect({
      account: this.authService.instance.getActiveAccount(),
      authority: ConfigConstants.AZURE_AUTHORITY,
      postLogoutRedirectUri: '/',
    });
  }
}
